import { Component, Input, Output } from '@angular/core';

@Component({
  selector: 'dynamic-header',
  templateUrl: './dynamic-header.component.html'
})
export class DynamicHeaderComponent {
  @Input() header: any;
}
